import styled from 'styled-components';

import DefaultUpload from 'ui/components/Upload';

import { Typography } from 'antd';

export const Upload = styled(DefaultUpload)`
  .ant-upload-list-item {
    margin: 0;
  }
`;

export const UploadTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
`;

export const Paragraph = styled(Typography.Paragraph)`
  &.ant-typography {
    margin-bottom: 0;
  }
`;
